
import { Form } from '../components/AllForm/AllForm';
export const Dashboard = () => {
  

  return (
    <>
      <Form />
    </>
  );
};
